
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    modalTitle: {
      type: String,
      default: "",
    },
  },
});
